import {useMutation, UseMutationOptions} from '@tanstack/react-query'
import {parseAxiosPromise} from '@/axiosInstance.ts'
import {httpCreateUserGroup, HttpCreateUserGroupOptions} from '@/features/user-groups/http/user-groups.http.ts'
import {captureException} from '@sentry/react'
import {UserGroup} from '@/features/user-groups/types.ts'
import {z} from 'zod'
import {MUTATION_KEYS} from '@/queryClient'

const ResponseShape = UserGroup
type ResponseShape = z.infer<typeof ResponseShape>

export const useCreateUserGroup = (
    options?: Omit<UseMutationOptions<ResponseShape, Error, HttpCreateUserGroupOptions, unknown>, 'mutationFn'>
) => {
    return useMutation({
        mutationKey: [MUTATION_KEYS.CREATE_USER_GROUP],
        mutationFn: (mutationParams: HttpCreateUserGroupOptions) =>
            parseAxiosPromise({
                axiosPromise: httpCreateUserGroup(mutationParams),
                onZodError: captureException,
                responseShape: ResponseShape
            }),
        ...options
    })
}
